import React from "react";
import CreateProduct from "../components/CreateProduct";
import { ShowProduct } from "../components/ShowProduct";

export default function HomePage() {
  return (
    <div className="productWrapper">
      <ShowProduct />
      <CreateProduct />
    </div>
  );
}
